import React from "react";

import { useUserIsLogged, useAuthActions } from '../../hooks';
import { SERVICES_URL } from '../../constants/appsUrls';
import { HEADER_MENU_ITEMS } from '../../constants/headerMenuItems';
import { toBucketAssets } from "../../utils/assets";

import Dropdown from '../Dropdown';
// import CountryDropdown from '../CountryDropdown';
import Button from '../Button';
import MobileMenu from '../MobileMenu';

const Header = () => {
  const { isLogged: isUserLoged } = useUserIsLogged();
  const { handleRedirectToLogin, handleRedirectToRegister, handleLogout } =
    useAuthActions();

  return (
    <header
      id="header-app"
      className="header_root"
    >
      <div className="header__toolbar">
        <a href={SERVICES_URL} className="header__main_logo__link">
          <img
            src={toBucketAssets('logo-km.svg')}
            alt="KM Logo"
            className="header__main_logo__img"
          />
        </a>

        <div className="header__content">
          <div className="header__nav_bar">
            {HEADER_MENU_ITEMS.map(({ label, data, dropdownMenuMinWidth }) => (
              <Dropdown
                key={`header-dropdown-${label}`}
                label={label}
                data={data}
                menuMinWidth={dropdownMenuMinWidth}
              />
            ))}
          </div>

          <div className="header__actions">
            {/* <CountryDropdown positionLeftMobile /> */}

            <div className="header__actions_auth">
              {!isUserLoged && (
                <>
                  <Button
                    type="button"
                    variant="text"
                    color="secondary"
                    size="small"
                    fullWidth
                    onClick={handleRedirectToLogin}
                    className="header__actions_auth_btn"
                    style={{ minWidth: 110 }}
                  >
                    Ingresar
                  </Button>

                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    size="small"
                    fullWidth
                    onClick={handleRedirectToRegister}
                    className="header__actions_auth_btn"
                    style={{ minWidth: 122 }}
                  >
                    Crear cuenta
                  </Button>
                </>
              )}

              {isUserLoged && (
                <Button
                  type="button"
                  variant="text"
                  color="secondary"
                  size="small"
                  fullWidth
                  onClick={handleLogout}
                  className="header__actions_auth_btn"
                  style={{ minWidth: 110 }}
                >
                  <img
                    src={toBucketAssets('icons/exit-purple.svg')}
                    alt="Logout"
                    className="header__actions_auth_btn_icon_img"
                  />

                  Salir
                </Button>
              )}
            </div>

            <MobileMenu isLogged={isUserLoged} />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
